import React from 'react';
import { motion } from 'framer-motion';

const IMG = {
  jazBefore: 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/ckm0e0fq_jaz%20before.png',
  jazAfter: 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/uq1oj4nn_jaz%20after.png',
  antonioBefore: 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/nnsfcgc9_antonio%20before.png',
  antonioAfter: 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/y64cwmy4_antonio%20after.png',
  sherryBefore: 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/05l19h81_sherry%20before.png',
  sherryAfter: 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/8wfcj339_sherry%20after.png',
  rosieBefore: 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/fzk582ou_rosie%20before.png',
  rosieAfter: 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/knba6l9v_rosie%20after.png',
};

const clients = [
  {
    key: 'jazz',
    name: 'Jazz',
    period: '8 Months',
    waist: '15 in off waist',
    muscle: '+6 lb muscle',
    before: IMG.jazBefore,
    after: IMG.jazAfter,
  },
  {
    key: 'antonio',
    name: 'Antonio',
    period: '1 Year',
    waist: '-68 pounds',
    muscle: 'Lean muscle gained',
    before: IMG.antonioBefore,
    after: IMG.antonioAfter,
  },
  {
    key: 'sherry',
    name: 'Sherry, Age 61',
    period: '10 Months',
    waist: '8 in off waist',
    muscle: '+5 lb muscle',
    before: IMG.sherryBefore,
    after: IMG.sherryAfter,
  },
  {
    key: 'rosie',
    name: 'Rosie',
    period: '5 Months',
    waist: '2.4 in off waist',
    muscle: 'Consistent while traveling',
    before: IMG.rosieBefore,
    after: IMG.rosieAfter,
  },
];

const Photo = ({ src, alt, label, right }) => (
  <div className="relative aspect-[3/4] w-full overflow-hidden rounded-md bg-neutral-900">
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="absolute inset-0 w-full h-full object-cover object-top"
    />
    <span
      className={`absolute top-2 ${
        right ? 'right-2 bg-gray-300 text-black' : 'left-2 bg-black/60 text-white/80'
      } text-[10px] font-bold tracking-[0.2em] px-2 py-1 rounded uppercase`}
    >
      {label}
    </span>
  </div>
);

export const Transformations = () => {
  return (
    <section
      id="results"
      data-testid="transformations"
      className="bg-black py-14 sm:py-16 lg:py-20 px-6 border-y border-neutral-900"
    >
      <div className="container mx-auto max-w-7xl">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.7 }}
          className="mb-10 lg:mb-14"
        >
          <p className="text-gray-400 font-bold text-xs tracking-[0.35em] uppercase mb-3">
            Client Transformations
          </p>
          <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl uppercase leading-none">
            Real Work. Real Results.
          </h2>
          <p className="text-gray-400 text-sm sm:text-base mt-4 max-w-xl">
            Proof built through structure, consistency, and coaching.
          </p>
        </motion.div>

        {/* Cards — 1 col mobile, 2 cols tablet+ */}
        <div className="grid sm:grid-cols-2 gap-5">
          {clients.map((c, i) => (
            <motion.div
              key={c.key}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.65, delay: (i % 2) * 0.08 }}
              data-testid={`transformation-card-${i}`}
              className="rounded-2xl border border-neutral-800 bg-neutral-950 p-4 sm:p-5 hover:border-neutral-600 transition-colors"
            >
              <div className="grid grid-cols-2 gap-3">
                <Photo src={c.before} alt={`${c.name} before`} label="Before" />
                <Photo src={c.after} alt={`${c.name} after`} label="After" right />
              </div>

              <div className="pt-5 mt-1 border-t border-neutral-800 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display text-white uppercase text-lg tracking-wide">{c.name}</h3>
                  <p className="text-gray-500 text-xs uppercase tracking-[0.15em] mt-1">{c.period}</p>
                </div>
                <div className="text-right">
                  <p className="font-display text-white uppercase text-sm tracking-wide">{c.waist}</p>
                  <p className="text-gray-400 text-xs mt-1">{c.muscle}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
